import { Alert, Col, Row, Space, Tag } from "antd";
import { CustomCard } from "../../../shared/components/CustomCard/CustomCard";
import {
  daysJsFormat,
  iconSwitchStatusControl,
  languagesList,
  renderEmailClickable,
  renderPhoneClickable,
  renderResponsable,
  renderStatusPrestation,
  renderStatusTag,
  renderTypePrestation,
  renderUserGender,
  renderUserName,
  roles,
  statusPrestationsValues,
  subStatus,
  typeIntervention,
  typeSwitchStatusControl,
} from "../../../utils/constants";
import { formatPhoneDisplay } from "../../../utils/phoneUtils";
import { RenderUpdatedCopy } from "../../../shared/components/RenderUpdatedCopy/RenderUpdatedCopy";
import {
  ActionRoleSpecific,
  onlyRoleMapping,
  UserCanDoActionMemo,
  userHasLevel,
} from "../../../engine/AuthRoute";
import routes from "../../../engine/routes";
import { Link, useParams } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { AiOutlineCalendar, AiOutlineClockCircle } from "react-icons/ai";
import dayjs from "../../../utils/dayjs";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";
import { renderAdress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { RenderControl1, RenderControl2 } from "./PrestationsResumeActions";

export const PrestationResumeCards = ({ registerRef }) => {
  const { prestation, loading, loadingAppel } = useSelector(
    state => state.prestation,
  );
  const { id } = useParams();

  const { isMobile } = useDeviceDetect();

  const prestationRef = useRef(prestation);

  useEffect(() => {
    prestationRef.current = prestation;
  }, [prestation]);

  const {
    reference,
    status,
    language,
    intervention,
    interventionFinal,
    interprete,
    changements,
    comment,
    institution,
    beneficiary,
    intervenant,
    billing,
    responsable,
    subStatus,
    applicant,
    isFollow,
    finalStartDate,
    finalEndDate,
  } = prestation;

  return (
    <>
      <RenderControl1 key={prestation._id} />
      <RenderControl2 key={prestation._id} />

      {status === statusPrestationsValues.draft && (
        <Alert
          // icon={iconSwitchStatusControl(control1.status, 1)}
          message={`Merci de vérifier que les informations ci-dessous sont bien correctes.
          Si c'est le cas, vous pouvez valider la commande à l'aide du bouton en
          bas de cette page.`}
          type={"info"}
          showIcon
          closable={true}
        />
      )}

      <Col span={24}>
        <CustomCard
          title={"Sommaire de la prestation"}
          openDefault={true}
          loading={loading}
        >
          <Row gutter={[10, 10]}>
            <Col span={12}>
              <span className={"resume-subtitle"}>N de commande</span>
              <span className={"resume-strong"}>{reference}</span>
            </Col>

            <Col span={12}>
              <span className={"resume-subtitle"}>Statut</span>
              <span>
                {renderStatusPrestation(prestation, {
                  showControls: userHasLevel({
                    only: {
                      [roles.permanance]: "crud", //
                      [roles.admin]: "crud", //
                    },
                  }),
                })}
              </span>
            </Col>

            <Col
              span={12}
              ref={elem => registerRef("intervention.startDate", elem)}
            >
              <span className={"resume-subtitle"}>
                Date et heure de début prévue
              </span>
              <RenderUpdatedCopy
                changesKey={"intervention.startDate"}
                data={{ "intervention.startDate": intervention.startDate }} // newStartDate should contain the updated date
              >
                <RenderDate />
              </RenderUpdatedCopy>
            </Col>
            <Col
              span={12}
              ref={elem => registerRef("intervention.endDate", elem)}
            >
              <span className={"resume-subtitle"}>
                Date et heure de fin prévu
              </span>
              <RenderUpdatedCopy
                changesKey={"intervention.endDate"}
                data={{ "intervention.endDate": intervention.endDate }} // newStartDate should contain the updated date
              >
                <RenderDate />
              </RenderUpdatedCopy>
            </Col>
            <Col span={12}>
              <span className={"resume-subtitle"}>Langue de la prestation</span>
              <span className={"resume-text"}>
                {languagesList.find(e => e.value === language[0])?.label}
              </span>
            </Col>
            <Col span={12} ref={elem => registerRef("intervention.type", elem)}>
              <span className={"resume-subtitle"}>Type de prestation</span>
              <RenderUpdatedCopy
                changesKey={"intervention.type"}
                data={{ "intervention.type": intervention.type }}
              >
                <RenderType />
              </RenderUpdatedCopy>
            </Col>

            {intervention?.locationName !== "" ||
            intervention?.location !== "" ? (
              <Col
                span={12}
                ref={elem => registerRef("intervention.location", elem)}
              >
                <span className={"resume-subtitle"}>
                  Lieu de l'intervention
                </span>

                <RenderUpdatedCopy
                  changesKey={"intervention.locationName"}
                  data={{
                    "intervention.locationName": intervention?.locationName,
                  }}
                >
                  <RenderBasic />
                </RenderUpdatedCopy>
                <RenderUpdatedCopy
                  changesKey={"intervention.location"}
                  data={{ "intervention.location": intervention?.location }}
                >
                  <RenderLocation />
                </RenderUpdatedCopy>
              </Col>
            ) : null}

            {intervention.type === typeIntervention.phone && [
              <Col span={12}>
                {/*<span className={"resume-subtitle"}>Numéro de téléphone</span>*/}
                {/*<RenderUpdatedCopy*/}
                {/*  changesKey={"intervention.phone"}*/}
                {/*  data={{ "intervention.phone": intervention?.phone }}*/}
                {/*>*/}
                {/*  <RenderPhone />*/}
                {/*</RenderUpdatedCopy>{" "}*/}
                {prestation.interprete?.info?.phone?.length > 0
                  ? [
                      <span className={"resume-subtitle"}>
                        Numéro de téléphone de l'interprète
                      </span>,
                      <RenderUpdatedCopy
                        changesKey={"prestation.interprete.info.phone"}
                        data={{
                          "prestation.interprete.info.phone":
                            prestation.interprete?.info?.phone,
                        }}
                      >
                        <RenderPhone />
                      </RenderUpdatedCopy>,
                    ]
                  : null}
              </Col>,
            ]}

            {intervention.type === typeIntervention.visio && (
              <Col span={12}>
                <span className={"resume-subtitle"}>
                  Lien de la visio-conférence
                </span>
                <RenderUpdatedCopy
                  changesKey={"intervention.linkVisio"}
                  data={{
                    "intervention.linkVisio": intervention?.linkVisio,
                  }}
                >
                  <RenderLink />
                </RenderUpdatedCopy>
              </Col>
            )}
            <Col span={12}>
              <span className={"resume-subtitle"}>
                Date de dépôt de la commande
              </span>
              <span className={"resume-text"}>
                {prestation.applicationAt !== null
                  ? dayjs(prestation.applicationAt).format(daysJsFormat.full)
                  : "-"}
              </span>
            </Col>
            {/*<Col span={12}>*/}
            {/*  <span className={"resume-subtitle"}>*/}
            {/*    Complément du lieu de l'intervention (Étage, Salle, Digicode)*/}
            {/*  </span>*/}
            {/*  <RenderUpdatedCopy*/}
            {/*    changesKey={"intervention.extra"}*/}
            {/*    data={{ "intervention.extra": intervention?.extra }}*/}
            {/*  >*/}
            {/*    <RenderBasic />*/}
            {/*  </RenderUpdatedCopy>*/}
            {/*</Col>*/}

            {intervention.extra !== "" && (
              <Col span={12}>
                <span className={"resume-subtitle"}>
                  Complément du lieu de l'intervention (Étage, Salle, Digicode)
                </span>
                <RenderUpdatedCopy
                  changesKey={"intervention.extra"}
                  data={{ "intervention.extra": intervention?.extra }}
                >
                  <RenderBasic />
                </RenderUpdatedCopy>
              </Col>
            )}

            <Col span={24}>
              <span className={"resume-subtitle"}>
                Commentaire pour l'interprète
              </span>
              <RenderUpdatedCopy
                changesKey={"comment.interprete"}
                data={{ "comment.interprete": comment?.interprete || "-" }}
              >
                <RenderBasic preserveLineBreaks />
              </RenderUpdatedCopy>
            </Col>

            {prestation?.batch_shared !== null &&
              prestation?.batch_shared !== undefined && (
                <Col span={12}>
                  <span className={"resume-subtitle"}>
                    Frais de déplacement partagés
                  </span>
                  {prestation?.batch_shared?.prestations?.map(e => {
                    return (
                      <Link
                        className={` ${
                          e._id === prestation.batch_shared.mainPrestation
                            ? "strongGrouped"
                            : ""
                        }`}
                        to={routes.prestations(e._id).detail.path}
                        style={{ flex: 1 }}
                      >
                        {e.reference}{" "}
                      </Link>
                    );
                  })}
                </Col>
              )}
          </Row>
        </CustomCard>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <CustomCard title={"Interprète"} height={"100%"} loading={loading}>
          <Row gutter={[10, 10]}>
            <UserCanDoActionMemo
              route={routes.prestations(id).detailResume}
              action={"r"}
            >
              <>
                <Col span={24}>
                  <span className={"resume-subtitle"}>Interprète</span>
                  <span className={"resume-text"}>
                    <Link to={routes.interpretes(interprete?._id).detail.path}>
                      {renderUserName(interprete)}
                    </Link>
                  </span>
                </Col>
                <Col span={24}>
                  <span className={"resume-subtitle"}>
                    Genre de l'interprète
                  </span>
                  <span className={"resume-text"}>
                    {renderUserGender(interprete)}
                  </span>
                </Col>

                {userHasLevel({
                  only: {
                    [roles.permanance]: "crud", //
                    [roles.admin]: "crud", //
                  },
                }) ? (
                  <>
                    {interventionFinal?.locationFrom ? (
                      <Col
                        span={24}
                        ref={elem => registerRef("intervention.location", elem)}
                      >
                        <span className={"resume-subtitle"}>
                          Lieu de départ de l'interprète
                        </span>
                        <RenderUpdatedCopy
                          changesKey={"interventionFinal.locationFrom"}
                          data={{
                            "interventionFinal.locationFrom":
                              interventionFinal?.locationFrom,
                          }}
                        >
                          <RenderLocation />
                        </RenderUpdatedCopy>
                      </Col>
                    ) : (
                      <Col
                        span={24}
                        ref={elem => registerRef("intervention.location", elem)}
                      >
                        <span className={"resume-subtitle"}>
                          Lieu de départ de l'interprète
                        </span>
                        <RenderUpdatedCopy
                          changesKey={"intervention.locationFrom"}
                          data={{
                            "intervention.locationFrom":
                              intervention?.locationFrom,
                          }}
                        >
                          <RenderLocation />
                        </RenderUpdatedCopy>
                      </Col>
                    )}
                  </>
                ) : null}

                <ActionRoleSpecific
                  only={[roles.admin, roles.permanance, roles.institution]}
                >
                  <Col span={24}>
                    <span className={"resume-subtitle"}>
                      Commentaire permanence AVIC
                    </span>
                    <RenderUpdatedCopy
                      changesKey={"comment.internal"}
                      data={{
                        "comment.internal": comment?.internal || "-",
                      }}
                    >
                      <RenderBasic preserveLineBreaks />
                    </RenderUpdatedCopy>
                  </Col>
                </ActionRoleSpecific>
              </>
            </UserCanDoActionMemo>
          </Row>
        </CustomCard>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <CustomCard title={"Institution"} height={"100%"} loading={loading}>
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <span className={"resume-subtitle"}>Institution</span>
              <span className={"resume-text"}>
                <Link to={routes.institutions(institution?._id).detail.path}>
                  {institution?.name}
                </Link>
              </span>
            </Col>
            <Col span={24}>
              <span className={"resume-subtitle"}>Facture envoyée à</span>
              <span className={""}>
                <b>{renderAdress(billing, false, prestation.institution)}</b>
              </span>
            </Col>
            <Col span={24}>
              <span className={"resume-subtitle"}>Références bénéficiaire</span>
              <RenderUpdatedCopy
                changesKey={"beneficiary.reference"}
                data={{ "beneficiary.reference": beneficiary?.reference }}
              >
                <RenderBasic theme={"light"} />
              </RenderUpdatedCopy>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "5px",
                }}
              >
                <RenderUpdatedCopy
                  changesKey={"beneficiary.firstname"}
                  data={{ "beneficiary.firstname": beneficiary?.firstname }}
                >
                  <RenderBasic theme={"light"} width={"auto"} />
                </RenderUpdatedCopy>
                <RenderUpdatedCopy
                  changesKey={"beneficiary.lastname"}
                  data={{ "beneficiary.lastname": beneficiary?.lastname }}
                >
                  <RenderBasic theme={"light"} width={"auto"} />
                </RenderUpdatedCopy>
              </div>
            </Col>
            <Col span={24}>
              <span className={"resume-subtitle"}>
                Personnel responsable de l’entretien
              </span>
              <span className={"resume-text"}>
                {renderResponsable(responsable)}
              </span>
              {responsable?.phone && (
                <span className={"resume-text"}>
                  {formatPhoneDisplay(responsable?.phone)}{" "}
                  {renderPhoneClickable(responsable?.phone)}
                </span>
              )}
              <span className={"resume-text"}>
                {renderEmailClickable(responsable?.email)}
              </span>
              {/*<RenderUpdatedCopy*/}
              {/*  changesKey={intervenant.name"}*/}
              {/*  data={{ "intervenant.name": intervenant?.name }}*/}
              {/*>*/}
              {/*  <RenderBasic theme={"light"} />*/}
              {/*</RenderUpdatedCopy>*/}
              {/*<RenderUpdatedCopy*/}
              {/*  changesKey={"intervenant.phone"}*/}
              {/*  data={{ "intervenant.phone": intervenant?.info?.phone }}*/}
              {/*>*/}
              {/*  <RenderBasic theme={"light"} />*/}
              {/*</RenderUpdatedCopy>*/}
              {/*<RenderUpdatedCopy*/}
              {/*  changesKey={"intervenant.email"}*/}
              {/*  data={{ "intervenant.email": intervenant?.email }}*/}
              {/*>*/}
              {/*  <RenderBasic theme={"light"} />*/}
              {/*</RenderUpdatedCopy>*/}
            </Col>
            <Col span={24}>
              <span className={"resume-subtitle"}>Demandeur</span>
              <span className={"resume-text"}>{renderUserName(applicant)}</span>

              {onlyRoleMapping([roles.admin, roles.permanance]) && (
                <>
                  <span className={"resume-text"}>
                    {renderEmailClickable(applicant?.email)}
                  </span>
                </>
              )}

              {onlyRoleMapping([
                roles.admin,
                roles.permanance,
                roles.interprete,
              ]) && (
                <>
                  <span className={"resume-text"}>
                    {formatPhoneDisplay(applicant?.info?.phone)}{" "}
                    {renderPhoneClickable(applicant?.info?.phone)}
                  </span>
                </>
              )}

              {/*<RenderUpdatedCopy*/}
              {/*  changesKey={"applicant.name"}*/}
              {/*  data={{*/}
              {/*    "applicant.name": applicant?.name,*/}
              {/*  }}*/}
              {/*>*/}
              {/*  <  RenderBasic theme={"light"} />*/}
              {/*</RenderUpdatedCopy>*/}
              {/*<RenderUpdatedCopy*/}
              {/*  changesKey={"applicant.phone"}*/}
              {/*  data={{*/}
              {/*    "applicant.phone": applicant?.info?.phone,*/}
              {/*  }}*/}
              {/*>*/}
              {/*  <RenderBasic theme={"light"} />*/}
              {/*</RenderUpdatedCopy>*/}
              {/*<RenderUpdatedCopy*/}
              {/*  changesKey={"applicant.email"}*/}
              {/*  data={{*/}
              {/*    "applicant.email": applicant?.email,*/}
              {/*  }}*/}
              {/*>*/}
              {/*  <RenderBasic theme={"light"} />*/}
              {/*</RenderUpdatedCopy>*/}
            </Col>
          </Row>
        </CustomCard>
      </Col>
    </>
  );
};

export const RenderDate = props => (
  <div style={{ width: "100%" }}>
    <Space direction={"horizontal"} className={props.className}>
      <span className={"resume-text"}>
        <AiOutlineCalendar size={20} />
        {dayjs(props[props.dataKey]).format(daysJsFormat.day)}
      </span>
      <span className={"resume-text"}>
        <AiOutlineClockCircle size={20} />
        {dayjs(props[props.dataKey]).format(daysJsFormat.hour)}
      </span>
    </Space>
  </div>
);

const RenderType = props => (
  <div style={{ width: "100%" }}>
    <span className={" resume-text"}>
      <b className={props.className}>
        {renderTypePrestation(props[props.dataKey])}
      </b>
    </span>
  </div>
);

const RenderLocation = props => (
  <div style={{ width: "100%" }}>
    <a
      className={props.className}
      href={`https://www.google.com/maps/search/?api=1&query=${
        props[props.dataKey]
      }`}
      target={"_blank"}
    >
      {props[props.dataKey]}
    </a>
  </div>
);

const RenderLink = props => (
  <div style={{ width: "100%" }}>
    <a
      className={props.className}
      href={`${props[props.dataKey]}`}
      target={"_blank"}
    >
      {props[props.dataKey]}
    </a>
  </div>
);

const RenderBasic = props => (
  <div style={{ width: props.width || "100%" }}>
    <span className={" resume-text"}>
      {props.theme === "light" ? (
        <span
          className={props.className}
          style={
            props.preserveLineBreaks
              ? { whiteSpace: "pre-wrap", overflowWrap: "anywhere" }
              : undefined
          }
        >
          {props[props.dataKey]}
        </span>
      ) : (
        <b
          className={props.className}
          style={
            props.preserveLineBreaks
              ? { whiteSpace: "pre-wrap", overflowWrap: "anywhere" }
              : undefined
          }
        >
          {props[props.dataKey]}
        </b>
      )}
    </span>
  </div>
);

const RenderPhone = props => (
  <div style={{ width: props.width || "100%" }}>
    <span className={" resume-text"}>
      {props.theme === "light" ? (
        <span className={props.className}>
          {formatPhoneDisplay(props[props.dataKey])}
        </span>
      ) : (
        <>
          <b className={props.className}>
            {formatPhoneDisplay(props[props.dataKey])}
          </b>
          {renderPhoneClickable(props[props.dataKey])}
        </>
      )}
    </span>
  </div>
);
